import React from 'react';
import { PlayIcon, XIcon, VolumeXIcon } from 'lucide-react';
import { contrastSurfaces, contrastTokens, forbidden, sounds, typeScale } from '../../data/atmosphere';
import { contrastRatio } from '../../utils/color';
import { playSound } from '../../utils/sound';
export function TypeAndSound() {
  return <div className="mt-20 grid gap-14 lg:grid-cols-12" data-id="element-1090" data-mp="3pdyjbgnxxt0">
      <div className="lg:col-span-7" data-id="element-1091" data-mp="3qyo0mo4eqk0">
        <h3 className="text-[20px] font-semibold text-ink" data-id="element-1092" data-mp="3uv6vjosrrg1v">Typografie</h3>
        <p className="mt-1 text-[15px] text-ink-muted" data-id="element-1093" data-mp="3q4gtoljjxvbx">
          Inter voor de interface. Outfit Light voor Anna’s gesproken zinnen.
        </p>
        <div className="mt-6 divide-y divide-white/[0.06]" data-id="element-1094" data-mp="3l5vos8tcunh5">
          {typeScale.map(t => <div key={t.role} className="grid gap-2 py-6 sm:grid-cols-[200px_1fr] sm:gap-8" data-id="element-1095" data-mp="3g7c1a3z453mo">
              <div data-id="element-1096" data-mp="3c34dc90hbrpi">
                <p className="text-[14px] font-semibold text-ink" data-id="element-1097" data-mp="3c3mg7ohnd46e">{t.role}</p>
                <p className="text-[13px] text-ink-muted" data-id="element-1098" data-mp="376nplfx6zfcy">{t.spec}</p>
              </div>
              <p className={`text-ink ${t.className}`} data-id="element-1099" data-mp="3fs6gqnq8r7r">{t.sample}</p>
            </div>)}
        </div>
      </div>

      <div className="space-y-12 lg:col-span-5" data-id="element-1100" data-mp="894h1wvkmxhi">
        <div data-id="element-1101" data-mp="3qlstcmusjv95">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1102" data-mp="3qmc4nkpxrle7">Contrast</h3>
          <p className="mt-1 text-[15px] text-ink-muted" data-id="element-1103" data-mp="3un4fujidc0d4">Geen grijze tekst onder 4,5:1.</p>
          <table className="mt-5 w-full text-left" data-id="element-1104" data-mp="m7b92wdua399">
            <thead data-id="element-1105" data-mp="m8ma4ofwgwwo">
              <tr className="border-b border-white/[0.08] text-[13px] text-ink-muted" data-id="element-1106" data-mp="m844503fr4bk">
                <th scope="col" className="py-2.5 font-medium" data-id="element-1107" data-mp="r5vzy577bal1">Token</th>
                {contrastSurfaces.map(s => <th key={s.name} scope="col" className="py-2.5 text-right font-medium" data-id="element-1108" data-mp="d8qyyjmch1wn">Op {s.name.toLowerCase()}</th>)}
              </tr>
            </thead>
            <tbody data-id="element-1109" data-mp="2xvakt6bat1oc">
              {contrastTokens.map(tok => <tr key={tok.name} className="border-b border-white/[0.05]" data-id="element-1110" data-mp="32w8by8ead61z">
                  <th scope="row" className="py-3 font-normal" data-id="element-1111" data-mp="18fgokh4ud4wa">
                    <span className="text-[15px] font-medium" style={{
                  color: tok.hex
                }} data-id="element-1112" data-mp="18eylp1nobsfe">{tok.name}</span>
                    <span className="ml-2 text-[13px] text-ink-muted" data-id="element-1113" data-mp="13iq7prl7q59t">{tok.use}</span>
                  </th>
                  {contrastSurfaces.map(s => <td key={s.name} className="py-3 text-right text-[14px] tabular-nums text-ink-soft" data-id="element-1114" data-mp="una9kydfd3yf">
                      {contrastRatio(tok.hex, s.hex).toFixed(1).replace('.', ',')}:1
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>

        <div data-id="element-1115" data-mp="frkr3a7g78yg">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1116" data-mp="ft5coabsbhk6">Geluid</h3>
          <p className="mt-1 flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-1117" data-mp="bqshgfunz21n">
            <VolumeXIcon className="h-4 w-4" aria-hidden data-id="element-1118" data-mp="2a42ag6p61oxt" /> Gedempt in Niet storen en Slapen.
          </p>
          <ul className="mt-5 space-y-3" data-id="element-1119" data-mp="264jr3fcztlx3">
            {sounds.map(s => <li key={s.id} className="flex items-center gap-4" data-id="element-1120" data-mp="3o1n468xffvkk">
                <button type="button" onClick={() => playSound(s.id)} aria-label={`Speel ${s.name}`} className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/10 text-ink-soft transition-colors duration-150 hover:border-accent/50 hover:text-accent" data-id="element-1121" data-mp="3nzamlwvkzn81">
                  <PlayIcon className="h-4 w-4" aria-hidden data-id="element-1122" data-mp="353u196mszln6" />
                </button>
                <div data-id="element-1123" data-mp="3a259xe1d3q3t">
                  <p className="text-[15px] font-medium text-ink" data-id="element-1124" data-mp="3a1m1qp1ikg2z">{s.name}</p>
                  <p className="text-[14px] text-ink-muted" data-id="element-1125" data-mp="3e260ty5ndtrr">{s.when}</p>
                </div>
              </li>)}
          </ul>
        </div>

        <div data-id="element-1126" data-mp="tcqa136fi524">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1127" data-mp="td87g34tupbm">Niet toegestaan</h3>
          <ul className="mt-4 space-y-2.5" data-id="element-1128" data-mp="ybt6hz8cf2yh">
            {forbidden.map(f => <li key={f} className="flex items-start gap-3 text-[15px] text-ink-soft" data-id="element-1129" data-mp="ydmfvmacc1a6">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink-muted" aria-hidden data-id="element-1130" data-mp="wwqhh49qqzkj" /> {f}
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}